//src/App/Data/Forms/Billings/Returns/forms.js

const forms = [
  {
    name: "Billings Returns",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    options: [
      {
        name: "Customer",
        type: "selectandadd",
        path: "/app/customers/add",
        form: {
          name: "customer",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Customer",
          api: "get-all-customers",
          options: null,
          value: null,
          required: false,
        },
      },
      /*  {
         name: "Number",
         type: "input",
         form: {
           type: "text",
           name: "number",
           placeholder: "Invoice number",
           class: "",
           value: "",
           required: true,
         },
       }, */
      {
        name: "Number",
        type: "select",
        form: {
          type: "text",
          name: "number",
          placeholder: "Invoice number",
          api: "get-all-invoices",
          source: "Sales-Return",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Invoice date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Due Date",
        type: "date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Invoice due date",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
